import {
  Container,
  Navigation,
  UserContainer,
  Logo,
  UserText,
  SelectedLanguage,
  LogoutContainer,
  EndServiceAndIconEyeContainer,
  SelectedLanguageContainer,
  LanguageDropdownContainer,
  FlagContainer,
  FlagText,
  Flag,
  LanguageContainer,
  EndServiceItens,
  UserIconWrapper,
  InfoContainer,
} from "./styles";
import { useDispatch, useSelector } from "react-redux";
import { useEffect, useState } from "react";
import LogoCircle from "../../newUXAssets/images/informa_logo_circle.png";
import brazilFlag from "../../assets/images/brazil.png";
import ukFlag from "../../assets/images/uk-flag.png";
import { FiLogOut } from "react-icons/fi";
import EndServiceButton from "../EndServiceButton";
import ServiceTimer from "../ServiceTimer";
import { useIntl } from "react-intl";
import { changeLanguagePreference } from "../../redux/modules/language/actions";
import UserIcon from "../../newUXAssets/icons/User";

function TopBarStaffOperations() {
  const intl = useIntl();
  const dispatch = useDispatch();
  const { user, token } = useSelector((state) => state.auth);
  const { code } = useSelector((state) => state.language);
  const languages = [
    { code: "pt", flag: brazilFlag, text: "Português" },
    { code: "en", flag: ukFlag, text: "English" },
  ];
  const [activeFlag, setActiveFlag] = useState(ukFlag);
  const [languageVisible, setLanguageVisible] = useState(false);

  useEffect(() => {
    const language = languages.find((language) => language.code === code);
    if (language) {
      setActiveFlag(language.flag);
    }
  }, [code]);

  const handleLogout = () => {
    window.location.href = process.env.REACT_APP_LOGOUT_URI;
  };

  const currentRoute = window.location.pathname;

  const routesWithServiceTimerInHeader = [
    "/staff-access/services/contract",
    "/staff-access/services/sales",
    "/staff-access/services/transfer-history",
    "/staff-access/credentials/collaborators",
    "/staff-access/services/credentials",
  ];

  const handleLanguageChange = (language) => {
    dispatch(
      changeLanguagePreference({
        code: language,
        token: token,
      })
    );
  };
  const handleLanguageDropdown = () => {
    if (languageVisible) {
      setLanguageVisible(false);
    } else {
      setLanguageVisible(true);
    }
  };

  return (
    <Container>
      <Navigation>
        <EndServiceAndIconEyeContainer>
          <Logo src={LogoCircle} />
          {routesWithServiceTimerInHeader.includes(currentRoute) && (
            <EndServiceItens>
              <ServiceTimer header />
              <EndServiceButton header />
            </EndServiceItens>
          )}
        </EndServiceAndIconEyeContainer>
        <InfoContainer>
          <UserContainer>
            <UserIconWrapper>
              <UserIcon />
            </UserIconWrapper>
            <UserText>{user?.name || ""}</UserText>
          </UserContainer>

          <LanguageContainer>
            <SelectedLanguageContainer>
              <SelectedLanguage
                onClick={() => handleLanguageDropdown()}
                src={activeFlag}
                size={24}
              />
            </SelectedLanguageContainer>
            {languageVisible && (
              <LanguageDropdownContainer>
                {languages.map((language, index) => (
                  <FlagContainer
                    key={index}
                    onClick={() => handleLanguageChange(language.code)}
                  >
                    <Flag src={language.flag} />
                    <FlagText>{language.text}</FlagText>
                  </FlagContainer>
                ))}
              </LanguageDropdownContainer>
            )}
          </LanguageContainer>

          <LogoutContainer onClick={() => handleLogout()}>
            <FiLogOut
              style={{ marginRight: "5px" }}
              size={20}
              color="rgba(17, 167, 217, 1)"
            />

            <UserText logout>{intl.formatMessage({ id: "logout" })}</UserText>
          </LogoutContainer>
        </InfoContainer>
      </Navigation>
    </Container>
  );
}

export default TopBarStaffOperations;
